import Field from "@/components/contact/Field";
import ContactSubmitRow from "@/components/contact/ContactSubmitRow";
import useContactForm from "@/hooks/useContactForm";
import { CONTACT } from "@/constants/testIds";

const DESTS = [
  "India",
  "Nepal",
  "Bhutan",
  "Sri Lanka",
  "A multi-country journey",
  "Not sure yet",
];

const INPUT_CLASS =
  "w-full bg-transparent border-0 border-b border-line-dark py-3 text-lg font-light focus:outline-none focus:border-indigo_deep placeholder:text-ink/40";

export default function ContactForm() {
  const { form, status, errorMsg, update, submit } = useContactForm();

  return (
    <form
      onSubmit={submit}
      data-testid={CONTACT.form}
      className="col-span-12 md:col-span-7 space-y-10"
    >
      <Field label="Your name" htmlFor="name">
        <input
          id="name"
          data-testid={CONTACT.name}
          required
          value={form.name}
          onChange={(e) => update("name", e.target.value)}
          className={INPUT_CLASS}
          placeholder="Eleanor Whitmore"
        />
      </Field>

      <Field label="Email" htmlFor="email">
        <input
          id="email"
          type="email"
          data-testid={CONTACT.email}
          required
          value={form.email}
          onChange={(e) => update("email", e.target.value)}
          className={INPUT_CLASS}
          placeholder="you@example.com"
        />
      </Field>

      <Field label="Destination of interest" htmlFor="destination">
        <select
          id="destination"
          data-testid={CONTACT.destination}
          value={form.destination}
          onChange={(e) => update("destination", e.target.value)}
          className={`${INPUT_CLASS} appearance-none cursor-pointer`}
        >
          <option value="">Select a region</option>
          {DESTS.map((d) => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>
      </Field>

      <Field label="Subject" htmlFor="subject">
        <input
          id="subject"
          data-testid={CONTACT.subject}
          value={form.subject}
          onChange={(e) => update("subject", e.target.value)}
          className={INPUT_CLASS}
          placeholder="Honeymoon in Bhutan, late October"
        />
      </Field>

      <Field label="Tell us about your journey" htmlFor="message">
        <textarea
          id="message"
          data-testid={CONTACT.message}
          required
          rows={6}
          value={form.message}
          onChange={(e) => update("message", e.target.value)}
          className={`${INPUT_CLASS} resize-none`}
          placeholder="Travellers, approximate dates, pace, interests, anything you wish us to know…"
        />
      </Field>

      <ContactSubmitRow status={status} errorMsg={errorMsg} />
    </form>
  );
}
